"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainName2IdMap = exports.isValidObject = exports.RANDOM_LENGTH = exports.isBrowser = exports.resolveLocalStorage = exports.hasLocalStorage = exports.hasBuiltInWebSocket = exports.resolveWebSocketImplementation = void 0;
exports.hexToByteArray = hexToByteArray;
exports.getChainId = getChainId;
exports.toHexString = toHexString;
exports.concatUint8Arrays = concatUint8Arrays;
exports.splitToUint8Arrays = splitToUint8Arrays;
exports.base64encode = base64encode;
exports.base64decode = base64decode;
exports.checkWSUrl = checkWSUrl;
exports.hashKey = hashKey;
exports.generateRandomBytes32 = generateRandomBytes32;
exports.generateTopic = generateTopic;
exports.generateGroupId = generateGroupId;
exports.isInIOSLine = isInIOSLine;
exports.isInIOSLark = isInIOSLark;
exports.isInIOSChrome = isInIOSChrome;
exports.isInIOSWeChat = isInIOSWeChat;
exports.isIos = isIos;
exports.getLastSixMd5Hash = getLastSixMd5Hash;
exports.toSafeBase64FromBase64 = toSafeBase64FromBase64;
exports.useShortLink = useShortLink;
exports.replaceChainNameToChainId = replaceChainNameToChainId;
exports.replaceChainIdToChainName = replaceChainIdToChainName;
exports.getNamespaceKeyByChain = getNamespaceKeyByChain;
exports.scopePollingDetectionStrategy = scopePollingDetectionStrategy;
const tweetnacl_1 = __importDefault(require("tweetnacl"));
const tweetnacl_util_1 = __importDefault(require("tweetnacl-util"));
const to_string_1 = require("uint8arrays/to-string");
const sha256_1 = require("@stablelib/sha256");
const safejson_1 = require("./safejson");
const log_1 = require("./log");
const stringUtils_1 = require("../utils/stringUtils");
const crypto_js_1 = __importDefault(require("crypto-js"));
const protocol_1 = require("../protocol");
const BASE16 = "base16";
function hexToByteArray(hexString) {
    if (hexString.length % 2 !== 0) {
        throw new Error(`Cannot convert ${hexString} to bytesArray`);
    }
    const result = new Uint8Array(hexString.length / 2);
    for (let i = 0; i < hexString.length; i += 2) {
        result[i / 2] = parseInt(hexString.slice(i, i + 2), 16);
    }
    return result;
}
function getChainId(chain) {
    return chain.includes(":") ? chain.split(":")[1] : chain;
}
function toHexString(byteArray) {
    let hexString = '';
    byteArray.forEach(byte => {
        hexString += ('0' + (byte & 0xff).toString(16)).slice(-2);
    });
    return hexString;
}
function concatUint8Arrays(buffer1, buffer2) {
    const mergedArray = new Uint8Array(buffer1.length + buffer2.length);
    mergedArray.set(buffer1);
    mergedArray.set(buffer2, buffer1.length);
    return mergedArray;
}
function splitToUint8Arrays(array, index) {
    if (index >= array.length) {
        throw new Error('Index is out of buffer');
    }
    const subArray1 = array.slice(0, index);
    const subArray2 = array.slice(index);
    return [subArray1, subArray2];
}
function encodeUint8Array(value, urlSafe) {
    const encoded = tweetnacl_util_1.default.encodeBase64(value);
    if (!urlSafe) {
        return encoded;
    }
    return encodeURIComponent(encoded);
}
function decodeToUint8Array(value, urlSafe) {
    if (urlSafe) {
        value = decodeURIComponent(value);
    }
    return tweetnacl_util_1.default.decodeBase64(value);
}
function base64encode(value, urlSafe) {
    let uint8Array;
    if (value instanceof Uint8Array) {
        uint8Array = value;
    }
    else {
        if (typeof value !== 'string') {
            value = (0, safejson_1.safeJsonStringify)(value);
        }
        uint8Array = tweetnacl_util_1.default.decodeUTF8(value);
    }
    return encodeUint8Array(uint8Array, urlSafe);
}
function base64decode(value, urlSafe) {
    const decodedUint8Array = decodeToUint8Array(value, urlSafe);
    return {
        toString() {
            return tweetnacl_util_1.default.encodeUTF8(decodedUint8Array);
        },
        toObject() {
            try {
                return (0, safejson_1.safeJsonParse)(tweetnacl_util_1.default.encodeUTF8(decodedUint8Array));
            }
            catch (e) {
                return null;
            }
        },
        toUint8Array() {
            return decodedUint8Array;
        }
    };
}
function checkWSUrl(url) {
    const match = url.match(new RegExp(/^\w+:/, "gi"));
    if (!match || !match.length) {
        return false;
    }
    let scheme = match[0];
    if (scheme === undefined) {
        return false;
    }
    return new RegExp("^wss?:").test(scheme);
}
const resolveWebSocketImplementation = () => {
    if (typeof WebSocket !== "undefined") {
        return WebSocket;
    }
    else if (typeof global !== "undefined" && typeof global.WebSocket !== "undefined") {
        return global.WebSocket;
    }
    else if (typeof window !== "undefined" && typeof window.WebSocket !== "undefined") {
        return window.WebSocket;
    }
    else if (typeof self !== "undefined" && typeof self.WebSocket !== "undefined") {
        return self.WebSocket;
    }
    return WebSocket;
    //
    // return require("ws");
};
exports.resolveWebSocketImplementation = resolveWebSocketImplementation;
const hasBuiltInWebSocket = () => typeof WebSocket !== "undefined" ||
    (typeof global !== "undefined" && typeof global.WebSocket !== "undefined") ||
    (typeof window !== "undefined" && typeof window.WebSocket !== "undefined") ||
    (typeof self !== "undefined" && typeof self.WebSocket !== "undefined");
exports.hasBuiltInWebSocket = hasBuiltInWebSocket;
const hasLocalStorage = () => (typeof global !== "undefined" && (typeof global.localStorage !== "undefined")) ||
    (typeof window !== "undefined" && typeof window.localStorage !== "undefined");
exports.hasLocalStorage = hasLocalStorage;
const resolveLocalStorage = () => {
    if (typeof global !== "undefined" && typeof global.localStorage !== "undefined") {
        return global.localStorage;
    }
    else if (typeof window !== "undefined" && typeof window.localStorage !== "undefined") {
        return window.localStorage;
    }
    return localStorage;
};
exports.resolveLocalStorage = resolveLocalStorage;
const isBrowser = () => typeof window !== "undefined";
exports.isBrowser = isBrowser;
exports.RANDOM_LENGTH = 32;
function hashKey(key, encode = BASE16) {
    (0, log_1.logDebug)(`hash key called ${key}`);
    const result = (0, sha256_1.hash)((0, stringUtils_1.okxfromString)(key, encode));
    return (0, to_string_1.toString)(result, encode);
}
function generateRandomBytes32() {
    return tweetnacl_1.default.randomBytes(exports.RANDOM_LENGTH);
}
function generateTopic() {
    let randomBytes32 = generateRandomBytes32();
    (0, log_1.logDebug)(`generate topic called ${randomBytes32}`);
    return hashKey((0, to_string_1.toString)(randomBytes32, BASE16));
}
function generateGroupId() {
    let randomBytes32 = tweetnacl_1.default.randomBytes(16);
    (0, log_1.logDebug)(`generate groupid called ${randomBytes32}`);
    return hashKey((0, to_string_1.toString)(randomBytes32, BASE16));
}
const isValidObject = (obj) => Object.getPrototypeOf(obj) === Object.prototype && Object.keys(obj).length;
exports.isValidObject = isValidObject;
function isInIOSLine() {
    const userAgent = navigator.userAgent;
    const inLine = userAgent.includes('Safari Line/');
    return inLine && isIos();
}
function isInIOSLark() {
    const userAgent = navigator.userAgent;
    const inLine = userAgent.includes('Lark/');
    return inLine && isIos();
}
function isInIOSChrome() {
    const userAgent = navigator.userAgent;
    const inLine = userAgent.includes('CriOS/');
    return inLine && isIos();
}
function isInIOSWeChat() {
    const userAgent = navigator.userAgent;
    const inLine = userAgent.includes('MicroMessenger/');
    return inLine && isIos();
}
function isIos() {
    const userAgent = navigator.userAgent;
    const maxTouchPoints = navigator.maxTouchPoints || 0;
    // 检测 iPhone、iPod 和传统的 iPad
    const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    // 针对 iPadOS 13 及以上的设备进行额外判断
    const isIPadOS = (userAgent.includes('Mac') && maxTouchPoints > 1);
    (0, log_1.logDebug)(`utils isIos >>>isIOSDevice: ${isIOSDevice}    >> isIPadOS: ${isIPadOS}`);
    // 如果是 iOS 设备或者是 iPadOS 设备，返回 true
    return isIOSDevice || isIPadOS;
}
function getLastSixMd5Hash(input) {
    // 生成 MD5 哈希
    const hash = crypto_js_1.default.MD5(input).toString();
    // 获取最后六位
    return hash.slice(-6);
}
function toSafeBase64FromBase64(base64) {
    return base64
        .replace(/=/g, "")
        .replace(/\+/g, "-")
        .replace(/\//g, "_");
}
function useShortLink() {
    // return !!(window as any).useShortLink;
    return true;
}
exports.chainName2IdMap = new Map();
exports.chainName2IdMap.set("aptos:mainnet", "aptos:637");
exports.chainName2IdMap.set("movement:testnet", "aptos:70000060");
exports.chainName2IdMap.set("movement:mainnet", "aptos:70000066");
exports.chainName2IdMap.set("soon:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp", "svm:70000069");
exports.chainName2IdMap.set("soon:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z", "svm:70000067");
exports.chainName2IdMap.set("eclipse:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp", "svm:70000068");
exports.chainName2IdMap.set("sonic:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp", "svm:70000073");
function replaceChainNameToChainId(chainId) {
    exports.chainName2IdMap.forEach((value, key) => {
        if (chainId.includes(key)) {
            chainId = chainId.replace(key, value);
        }
    });
    return chainId;
}
function replaceChainIdToChainName(chainId) {
    exports.chainName2IdMap.forEach((value, key) => {
        if (chainId.includes(value)) {
            chainId = chainId.replace(value, key);
        }
    });
    return chainId;
}
function getNamespaceKeyByChain(chain) {
    for (const [namespaceKey, chains] of Object.entries(protocol_1.NAMES_CHAINS)) {
        if (Object.values(chains).includes(chain)) {
            return namespaceKey;
        }
    }
    return chain;
}
function scopePollingDetectionStrategy(detect) {
    // Early return when server-side rendering
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return;
    const disposers = [];
    function detectAndDispose() {
        const detected = detect();
        if (detected) {
            for (const dispose of disposers) {
                dispose();
            }
        }
    }
    // Strategy #1: Try detecting every second.
    const interval = 
    // TODO: #334 Replace with idle callback strategy.
    setInterval(detectAndDispose, 1000);
    disposers.push(() => clearInterval(interval));
    // Strategy #2: Detect as soon as the DOM becomes 'ready'/'interactive'.
    if (
    // Implies that `DOMContentLoaded` has not yet fired.
    document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', detectAndDispose, { once: true });
        disposers.push(() => document.removeEventListener('DOMContentLoaded', detectAndDispose));
    }
    // Strategy #3: Detect after the `window` has fully loaded.
    if (
    // If the `complete` state has been reached, we're too late.
    document.readyState !== 'complete') {
        window.addEventListener('load', detectAndDispose, { once: true });
        disposers.push(() => window.removeEventListener('load', detectAndDispose));
    }
    // Strategy #4: Detect synchronously, now.
    detectAndDispose();
}
